import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { getPipelineLeads , getPipelineStages,} from "../api";





const SRC_COLORS = {
  "Meta (Facebook)": "#185FA5",
  "Meta (Instagram)": "#D4537E",
  DV360: "#3B6D11",
  IVR: "#854F0B",
  "Google Ads": "#BA7517",
  Referral: "#0F6E56",
};

function fmtSecs(seconds) {
  const totalSeconds = Number(seconds || 0);

  if (totalSeconds <= 0) {
    return null;
  }

  return `${Math.floor(totalSeconds / 60)}m ${totalSeconds % 60}s`;
}

export default function Pipeline() {
  const [leads, setLeads] = useState([]);
  const [pipelineStages, setPipelineStages] = useState([]);
  const [stageCounts, setStageCounts] = useState({});
  const [loading, setLoading] = useState(true);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState("");

  const navigate = useNavigate();

  const load = useCallback(async () => {
  try {
    setLoading(true);

    const [leadsRes, stagesRes] = await Promise.all([
  getPipelineLeads(page, limit, {
    search,
  }),
  getPipelineStages(),
]);



    const responseData = leadsRes?.data || {};
    console.log("PIPELINE API RESPONSE:", responseData);

    setLeads(responseData?.data || []);

const receivedStages =
  Array.isArray(stagesRes?.data)
    ? stagesRes.data
    : Array.isArray(stagesRes?.data?.stages)
      ? stagesRes.data.stages
      : [];

setPipelineStages(receivedStages);

setStageCounts(responseData?.stageCounts || {});

    setTotalPages(Number(responseData?.totalPages || 1));

  } catch (error) {
    console.error("Pipeline load error:", error);

    setLeads([]);
setPipelineStages([]);
setStageCounts({});
setTotalPages(1);

  } finally {
    setLoading(false);
  }
}, [page, limit, search]);

  useEffect(() => {
    load();
  }, [load]);

  if (loading) {
  return (
    <div className="loading-screen">
      <div className="spinner" />
    </div>
  );
}

const normalizeStageValue = (value) =>
  String(value || "").trim();

const apiPipelineStages = pipelineStages
  .map((stage) => {
    const stageValue = normalizeStageValue(
      stage.stored_value ||
      stage.stage_name ||
      stage.display_name ||
      stage.name
    );

    if (!stageValue) {
      return null;
    }

    return {
      label:
        stage.display_name ||
        stage.stage_name ||
        stage.name ||
        stageValue,
      stage: stageValue,
      sub: stage.description || "",
      color: stage.color || "#64748b",
    };
  })
  .filter(Boolean);

const fallbackStageNames = [
  ...new Set([
    ...Object.keys(stageCounts || {}),
    ...leads
      .map((lead) =>
        normalizeStageValue(
          lead.stage ||
          lead.stage_name ||
          lead.display_name
        )
      )
      .filter(Boolean),
  ]),
];

const fallbackPipelineStages =
  fallbackStageNames.map((stageName) => ({
    label: stageName,
    stage: stageName,
    sub: "",
    color: "#64748b",
  }));

const dynamicPipelineStages =
  apiPipelineStages.length > 0
    ? apiPipelineStages
    : fallbackPipelineStages;

console.log(
  "FINAL PIPELINE STAGES:",
  dynamicPipelineStages
);

const byStage = dynamicPipelineStages.reduce(
  (result, item) => {
    const currentStage =
      normalizeStageValue(item.stage).toLowerCase();

    result[item.stage] = leads.filter((lead) => {
  const leadStage =
    normalizeStageValue(
      lead.pipeline_stage ||
      lead.stage ||
      lead.stage_name ||
      lead.display_name
    ).toLowerCase();

  return (
    currentStage &&
    leadStage === currentStage
  );
});

    return result;
  },
  {}
);

  const getStageCount = (stage) => {
  const requestedStage =
    normalizeStageValue(stage).toLowerCase();

  const matchingEntry = Object.entries(
    stageCounts || {}
  ).find(([stageName]) => {
    return (
      normalizeStageValue(
        stageName
      ).toLowerCase() === requestedStage
    );
  });

  return Number(matchingEntry?.[1] || 0);
};

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflow: "hidden",
      }}
    >
      {/* Top Stage Summary Boxes */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${Math.max(dynamicPipelineStages.length, 1)}, minmax(0, 1fr))`,
          gap: "10px",
          padding: "14px 20px",
          borderBottom: "0.5px solid rgba(0,0,0,0.08)",
          background: "#fff",
          flexShrink: 0,
        }}
      >
        {dynamicPipelineStages.map((item) => (
          <div className="metric-card" key={item.stage}>
            <div className="metric-label">
              <span
                style={{
                  display: "inline-block",
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  background: item.color,
                  marginRight: "7px",
                }}
              />

              {item.label}
            </div>

            <div className="metric-value">
              {getStageCount(item.stage)}
            </div>

            <div className="metric-sub">{item.sub}</div>
          </div>
        ))}
      </div>

      {/* Search, Page Size and Pagination */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 20px",
          background: "#fff",
          gap: "15px",
        }}
      >
        <div>
          <input
            type="text"
            placeholder="Search by Name / Phone"
            value={search}
            onChange={(event) => {
              setSearch(event.target.value);
              setPage(1);
            }}
            style={{
              width: "250px",
              padding: "8px",
              border: "1px solid #ccc",
              borderRadius: "6px",
            }}
          />
        </div>

        <div>
          Show:
          <select
            value={limit}
            onChange={(event) => {
              setLimit(Number(event.target.value));
              setPage(1);
            }}
            style={{
              marginLeft: "10px",
            }}
          >
            <option value={30}>30</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={200}>200</option>
            <option value={500}>500</option>
            <option value={1000}>1000</option>
          </select>
        </div>

        <div>
          <button
            disabled={page <= 1}
            onClick={() => setPage((currentPage) => currentPage - 1)}
          >
            ◀ Previous
          </button>

          <span style={{ margin: "0 15px" }}>
            Page {page} of {totalPages}
          </span>

          <button
            disabled={page >= totalPages}
            onClick={() => setPage((currentPage) => currentPage + 1)}
          >
            Next ▶
          </button>
        </div>
      </div>

      {/* Kanban Board */}
      <div
        style={{
          flex: 1,
          overflow: "hidden",
          padding: "14px 20px",
        }}
      >
        <div
          className="kanban-board"
          style={{
            gridTemplateColumns: `repeat(${Math.max(dynamicPipelineStages.length, 1)}, minmax(220px, 1fr))`,
          }}
        >
          {dynamicPipelineStages.map((item) => {
            const stageLeads = byStage[item.stage] || [];

            return (
              <div className="kanban-col" key={item.stage}>
                <div className="kanban-col-header">
                  <div className="kanban-col-title">
                    <span
                      className="kanban-col-dot"
                      style={{
                        background: item.color,
                      }}
                    />

                    {item.label}
                  </div>

                  <span className="kanban-col-count">
                    {stageLeads.length}
                  </span>
                </div>

                <div className="kanban-col-body">
                  {stageLeads.length === 0 && (
                    <div
                      style={{
                        fontSize: "11px",
                        color: "#aaa",
                        textAlign: "center",
                        padding: "20px 0",
                      }}
                    >
                      Empty
                    </div>
                  )}

                  {stageLeads.map((lead) => {
                    const callTime = lead.total_call_seconds;

                    const initials = (lead.assigned_to_name || "UN")
                      .split(" ")
                      .filter(Boolean)
                      .map((word) => word[0])
                      .join("")
                      .slice(0, 2)
                      .toUpperCase();

                    const sourceColor =
                      SRC_COLORS[lead.source] || "#888";

                    return (
                      <div
                        className="kanban-card"
                        key={lead.id}
                        onClick={() =>
  lead.deal_id
    ? navigate(`/deals/${lead.deal_id}`)
    : navigate(`/leads/${lead.id}`)
}
                      >
                        <div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    marginBottom: "4px",
  }}
>
  <div
    className="kanban-card-name"
    style={{
      color: lead.is_duplicate
        ? "#dc2626"
        : "#000",
      fontWeight: 600,
      minWidth: 0,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }}
    title={
      lead.is_duplicate
        ? "Duplicate Mobile Number"
        : lead.name || "Unnamed Lead"
    }
  >
    {lead.name || "Unnamed Lead"}
  </div>

  {lead.is_duplicate && (
    <span
      style={{
        flexShrink: 0,
        background: "#FEE2E2",
        color: "#DC2626",
        border: "1px solid #FECACA",
        borderRadius: "10px",
        padding: "2px 6px",
        fontSize: "9px",
        fontWeight: 700,
        lineHeight: 1.2,
      }}
      title="Same phone number already exists"
    >
      Duplicate
    </span>
  )}
</div>

                        <div className="kanban-card-meta">
  {lead.city || "No city"} ·{" "}
  {Number(lead.call_count || 0)} call
  {Number(lead.call_count || 0) !== 1
    ? "s"
    : ""}

  {Number(lead.pending_tasks || 0) > 0 &&
    ` · ${lead.pending_tasks} task${
      Number(lead.pending_tasks) > 1
        ? "s"
        : ""
    }`}
</div>

<div
  style={{
    fontSize: "10px",
    color: "#777",
    marginTop: "3px",
  }}
>
  Lead Date:{" "}
  {lead.created_at
    ? new Date(lead.created_at).toLocaleDateString("en-GB")
    : "-"}
</div>

                        {Number(lead.budget_cr || 0) > 0 && (
                          <div className="kanban-card-value">
                            ₹{lead.budget_cr}Cr
                            {lead.product_interest
                              ? ` — ${lead.product_interest}`
                              : ""}
                          </div>
                        )}

                        <div className="kanban-card-footer">
                          <span
                            className={`badge badge-${String(
                              lead.priority || "normal"
                            ).toLowerCase()}`}
                          >
                            {String(
                              lead.priority || "NORMAL"
                            ).toUpperCase()}
                          </span>

                          <span
                            className="badge"
                            style={{
                              background: `${sourceColor}18`,
                              color: sourceColor,
                              border: `0.5px solid ${sourceColor}30`,
                            }}
                          >
                            {(lead.source || "Unknown")
                              .split("(")[0]
                              .trim()
                              .split(" ")[0]}
                          </span>

                          {fmtSecs(callTime) && (
                            <span className="call-time-tag">
                              ⏱ {fmtSecs(callTime)}
                            </span>
                          )}

                          <span
                            className="assignee-circle"
                            title={
                              lead.assigned_to_name || "Unassigned"
                            }
                          >
                            {initials}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}